import {useEffect} from 'react'

/** `href` is `null` on the canonical route itself; `/inicio` points back at `/` so the landing is not indexed twice. */
export function useCanonicalLink(href: string | null) {
  useEffect(() => {
    if (!href) return
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]')
    const created = !link
    if (!link) {
      link = document.createElement('link')
      link.setAttribute('rel', 'canonical')
      document.head.appendChild(link)
    }
    link.setAttribute('href', href)
    return () => {
      if (created) link?.remove()
    }
  }, [href])
}
